import { render, staticRenderFns } from "./EmptyInfo.vue?vue&type=template&id=b14c70ca&scoped=true&"
import script from "./EmptyInfo.vue?vue&type=script&lang=js&"
export * from "./EmptyInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmptyInfo.vue?vue&type=style&index=0&id=b14c70ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14c70ca",
  null
  
)

export default component.exports